module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/header.3e9f6c53e6846f84.png";